import { isVNode, VNode } from 'vue';

import { isArray } from '@vue/shared';

export const flattedChildren = (children: VNode | Array<any>) => {
  const vNodes = isArray(children) ? children : [children];
  const result: Array<any> = [];

  vNodes.forEach((child) => {
    if (isArray(child)) {
      result.push(...flattedChildren(child));
    } else if (isVNode(child) && isArray(child.children)) {
      result.push(...flattedChildren(child.children));
    } else {
      result.push(child);
      if (isVNode(child) && child.component?.subTree) {
        result.push(...flattedChildren(child.component.subTree));
      }
    }
  });

  return result;
};
